export const PurchaseRequestStatus = [
  {
    id: 1,
    name: 'PURCHASEREQUESTSTATUS.NEW',
  },
  {
    id: 2,
    name: 'PURCHASEREQUESTSTATUS.WAITINGFORANSWER',
  },
  {
    id: 3,
    name: 'PURCHASEREQUESTSTATUS.WAITINGCONFIRMATION',
  },
  {
    id: 4,
    name: 'PURCHASEREQUESTSTATUS.POSITIVE',
  },
  {
    id: 5,
    name: 'PURCHASEREQUESTSTATUS.NEGATIVE',
  },
]
